/* Sticky-nav fallback fix - 08/06/2026.
   Bug: on some page loads, the <theme-header> custom element's
   connectedCallback() (defined in assets/theme.js) never attaches its
   `document.addEventListener("scroll", this.makeNavigationSticky)`
   listener. connectedCallback is written as one long comma-expression
   statement; if any earlier step in that chain throws (e.g. a
   layout-dependent element isn't measurable yet the instant the custom
   element upgrades), every statement after the failure point - including
   both addEventListener("scroll"/"resize", ...) calls - silently never
   runs. The rest of the custom element keeps working normally (its
   methods can still be called directly, computed correctly), so nothing
   ever throws a visible error - the nav just quietly never gets its
   `navigation--sticky` class added, and appears to scroll away instead
   of sticking to the top.

   Confirmed via direct testing: calling makeNavigationSticky() manually
   always works and toggles the class/position correctly - the toggle
   logic itself has no bug. The only thing missing is a reliable scroll
   listener actually calling it.

   Fix: once the page has fully loaded, attach our own independent
   scroll/resize listener that calls the existing instance's
   makeNavigationSticky() method directly. This does not touch or
   duplicate anything else connectedCallback does (section-reorder
   listeners, matchMedia handler, etc.) - it only guarantees the sticky
   toggle itself actually runs on scroll. If the native listener already
   attached successfully, this runs alongside it harmlessly (both just
   idempotently add/remove the same class based on the same scroll
   position). */
(function () {
  function wireStickyNav() {
    var header = document.querySelector('theme-header');
    var nav = document.querySelector('.js-navigation');
    if (!header || !nav || typeof header.makeNavigationSticky !== 'function') {
      return;
    }
    var tick = function () {
      header.makeNavigationSticky();
    };
    document.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick, { passive: true });
    // Run once immediately in case the page loaded already scrolled
    // (e.g. back/forward navigation restoring scroll position).
    tick();
  }

  if (document.readyState === 'complete') {
    wireStickyNav();
  } else {
    window.addEventListener('load', wireStickyNav);
  }
})();
